import { IEnrollmentDetails } from '../../../containers/individualPortal/myEnrollment/enrollmentHistoryTypes';
import { ENROLLMENT_HISTORY_ACTION_TYPES } from '../../../constants/actionTypes/enrollmentHistoryTypes';

interface IEnrollmentHistoryAction {
    type: string;
    payload?: any;
}
const sortEnrollment = (enrollments: IEnrollmentDetails[]) => {
    return enrollments.sort(function (a, b) {
        let a1 = a.coverageStartDate, b1 = b.coverageStartDate;
        if (a1 == b1) return 0;
        return a1 > b1 ? 1 : -1;
    })
}

export const INITIAL_STATE = {
    activeDentalEnrollments: [],
    activeHealthEnrollments: [],
    coverageStartDateForDisenrollment: '',
    inactiveDentalEnrollments: [],
    inactiveHealthEnrollments: [],
    errorMessage: ''
};

export default (state = INITIAL_STATE, action: IEnrollmentHistoryAction) => {
    switch (action?.type) {
        case ENROLLMENT_HISTORY_ACTION_TYPES.GET_ENROLLMENT_HISTORY:
            return {
                activeDentalEnrollments: sortEnrollment(action.payload.activeDentalEnrollments),
                activeHealthEnrollments: sortEnrollment(action.payload.activeHealthEnrollments),
                coverageStartDateForDisenrollment: action.payload.coverageStartDateForDisenrollment,
                inactiveDentalEnrollments: action.payload.inactiveDentalEnrollments,
                inactiveHealthEnrollments: action.payload.inactiveHealthEnrollments,
                errorMessage: ''
            };
        case ENROLLMENT_HISTORY_ACTION_TYPES.GET_ENROLLMENT_HISTORY_ERROR:
            return {
                ...state, 'errorMessage': action.payload
            };
        default:
            return state;
    }
};

